import { useEffect, useRef, useState } from 'react'

const useLayerDetails = (selectedLayer) => {
  const [selectedLayerDetails, setSelectedLayerDetails] = useState(null)
  const [showLayerDetails, setShowLayerDetails] = useState(false)
  const [hideLayerDetails, setHideLayerDetails] = useState(false)

  useEffect(() => {
    setSelectedLayerDetails(selectedLayer)
    setShowLayerDetails(false)
  }, [selectedLayer])

  const wrapperRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowLayerDetails(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  useEffect(() => {
    if (hideLayerDetails) {
      const timer = setTimeout(() => {
        setHideLayerDetails(false)
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [hideLayerDetails])

  const toggleShowLayerDetails = () => setShowLayerDetails(!showLayerDetails)

  return {
    selectedLayerDetails,
    showLayerDetails,
    hideLayerDetails,
    wrapperRef,
    toggleShowLayerDetails
  }
}

export default useLayerDetails
